// @ts-nocheck
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { makeStyles, Box, Button, Typography } from '@material-ui/core';
import { fetchCurrentUser, fetchToken, setAuthenticating } from '../state/authActions';
import { selectAuthenticated, selectAuthenticating } from '../state/authSelectors';
import { FullScreenLoading, Panel } from '../../../common/components';
import { AppRoute } from '../../app';
import AuthService from '../services/AuthService';
import { store } from '../../../core/store';
import { AuthUtils } from '../../../common/utils';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1',
    alignItems: 'center',
    justifyContent: 'center',
  },
  button: {
    alignSelf: 'center',
  },
  steps: {
    marginTop: 0,
    paddingLeft: '1.5em',
  },
}));

// axios' message when the browser returned no HTTP response (VPN down or Chrome's local network block).
const NETWORK_ERROR = 'Network Error';
const NETWORK_ERROR_STEPS = [
  'auth.networkErrorStepVpn',
  'auth.networkErrorStepSiteIcon',
  'auth.networkErrorStepAllow',
  'auth.networkErrorStepReload',
];

function AuthCallback() {
  const [error, setError] = useState('');
  const [buttonText, setButtonText] = useState('');
  const [t] = useTranslation();
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const authenticated = useSelector(selectAuthenticated);
  const authenticating = useSelector(selectAuthenticating);
  const dispatch = useDispatch();

  const onTryAgain = () => {
    if (!authenticating) {
      setButtonText(t('auth.refreshingToken'));
      setError(t('auth.authenticating'));
      store.dispatch(setAuthenticating(true, t('auth.authenticating')));
      AuthUtils.clearAuth();
      AuthService.fetchCode();
    } else {
      setError('');
      setButtonText('');
    }
  };

  useEffect(() => {
    async function handleFetchData(code) {
      try {
        if (code) {
          await dispatch(fetchToken(code));
        }
        await dispatch(fetchCurrentUser());
        history.replace(_.defaultTo(location.state?.from, AppRoute.Index));
      } catch (e) {
        setError(e.message);
      }
    }

    if (authenticating) {
      setButtonText(t('auth.refreshingToken'));
      setError(t('auth.authenticating'));
    } else if (!authenticated && !error) {
      let queryString = location.search || location.hash;
      if (queryString) {
        queryString = queryString.substr(1);

        const params = new URLSearchParams(queryString);
        const code = params.get('code');

        handleFetchData(code);
      } else {
        handleFetchData();
      }
    }
  }, [authenticated, authenticating, dispatch, error, history, location]);

  if (error) {
    return (
      <Box id="AuthCallback-error" className={classes.root}>
        <Panel id="AuthCallback-errorPanel" title={t('common.error')}>
          <Typography gutterBottom>{t('auth.authErrorMessage')}</Typography>
          <Typography gutterBottom>{`${t('common.reason')}: ${error}`}</Typography>
          {error === NETWORK_ERROR && (
            <Box id="AuthCallback-networkErrorHint">
              <Typography gutterBottom>{t('auth.networkErrorHint')}</Typography>
              <ol className={classes.steps}>
                {NETWORK_ERROR_STEPS.map(step => (
                  <Typography key={step} component="li" gutterBottom>
                    {t(step)}
                  </Typography>
                ))}
              </ol>
            </Box>
          )}
          <Button
            id="AuthCallback-retryButton"
            variant="contained"
            color="primary"
            className={classes.button}
            onClick={() => onTryAgain()}
            disabled={authenticating}
          >
            {buttonText || t('common.tryAgain')}
          </Button>
        </Panel>
      </Box>
    );
  }
  return <FullScreenLoading />;
}

export default AuthCallback;
